import { render, staticRenderFns } from "./ReservationScheduleTemplateTable.vue?vue&type=template&id=22c4c9a2&scoped=true&lang=pug"
import script from "./ReservationScheduleTemplateTable.vue?vue&type=script&lang=ts"
export * from "./ReservationScheduleTemplateTable.vue?vue&type=script&lang=ts"
import style0 from "./ReservationScheduleTemplateTable.vue?vue&type=style&index=0&id=22c4c9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c4c9a2",
  null
  
)

export default component.exports